import { CONTENT_API } from '../config'
import { authFetch } from './authFetch'
import type { FieldMapResponse } from '../types/fieldMap'

export type FieldMapDetail = 'compact' | 'full' | 'metrics'

/**
 * Fetch a post's field_map. Goes through `authFetch` so a 401 from an
 * expired access-token triggers one token refresh + retry — without
 * this the SalienceOverlay's 3s-polling loop floods the console with
 * permanent 401s after a JWT expires, even though the refresh-token
 * is still valid.
 */
export async function fetchFieldMap(
  postId: number,
  detail: FieldMapDetail = 'full',
): Promise<FieldMapResponse> {
  const url = `${CONTENT_API}/api/v1/field_map?scope=post:${postId}&detail=${detail}`
  const res = await authFetch(url, {
    headers: { 'Content-Type': 'application/json' },
  })
  if (!res.ok) {
    throw new Error(`field_map fetch failed: HTTP ${res.status}`)
  }
  return res.json() as Promise<FieldMapResponse>
}
